import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import client from "Libs/platform";

import type { TicketPriority } from "@packages/client";

export interface PrioritiesState {
  isLoading: boolean;
  priorities?: TicketPriority[];
  error?: unknown;
}

const initialState: PrioritiesState = {
  isLoading: false
};

// Thunks
export const loadPriorities = createAsyncThunk(
  "tickets/loadPriorities",
  async (
    {
      subscriptionId,
      categoryName
    }: { subscriptionId?: string; categoryName?: string },
    { rejectWithValue }
  ) => {
    try {
      const priorities = await client.getTicketPriorities(
        subscriptionId,
        categoryName
      );
      return priorities;
    } catch (error) {
      if (error instanceof Object) {
        return rejectWithValue(error);
      }
    }
  }
);

const priorities = createSlice({
  name: "tickets/priorities",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadPriorities.pending, state => {
        state.isLoading = true;
      })
      .addCase(loadPriorities.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.priorities = payload ?? [];
      })
      .addCase(loadPriorities.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error =
          payload ?? new Error("There was an error loading the priorities.");
      });
  }
});

export default priorities.reducer;
